export const SIZE_KB = 10
export const MAX_FILESIZE_MB = SIZE_KB * 1024 * 1024